<template>
  <div id="header">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
      <router-link :to="{name: 'Top'}" class="navbar-brand">
        動画共有
        <span
          class="badge badge-pill badge-secondary env dev"
          v-if="isDevelopment"
        >dev</span>
        <span
          class="badge badge-pill badge-secondary env stg"
          v-if="isStaging"
        >stg</span>
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbar-nav-items"
        aria-controls="navbar-nav-items"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div id="navbar-nav-items" class="collapse navbar-collapse" ref="refNavbarCollapse">
        <ul class="navbar-nav mr-auto" @click="onNavVarClick">
          <li class="nav-item" :class="{active: isPageTop}">
            <router-link :to="{name: 'Top'}" class="nav-link">
              地図
            </router-link>
          </li>
          <template v-if="isAdmin">
            <li class="nav-item" :class="{active: isAdminPageGroup}">
              <router-link :to="{name:'AdminTop'}" class="nav-link">
                管理画面
              </router-link>
            </li>
          </template>
          <template v-if="hasRoleSuperAdmin">
            <li class="nav-item" :class="{active: isDevDebugPageGroup}">
              <router-link :to="{name:'DevDebugTop'}" class="nav-link">
                開発者用画面
              </router-link>
            </li>
          </template>
        </ul>
        <div class="form-inline my-2 my-lg-0 nav-right-side" v-show="isLoggedIn">
          <span class="user-display-name">
            ユーザー名: {{ displayName }}
          </span>
          <a href="#" @click.prevent="logout" class="logout ml12">
            <i class="fas fa-sign-out-alt"></i>
            <span>ログアウト</span>
          </a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
import {
  computed,
  useTemplateRef,
} from 'vue';
import { useRoute } from 'vue-router';
import { useAuth } from 'src/composables/useAuth';
import { useEnv } from 'src/composables/useEnv';
import { clearSession } from 'src/services/session';

const auth = useAuth();
const { isDevelopment, isStaging } = useEnv();
const route = useRoute();
const refNavbarCollapse = useTemplateRef<HTMLElement>('refNavbarCollapse');

const displayName = computed<string>(() => auth.user?.displayName ?? '');
const isAdmin = computed<boolean>(() => {
  // 管理画面へのアクセス権限：部署管理者も含む
  return auth.user?.hasRoleDepartmentAdmin ?? false;
});
const hasRoleSuperAdmin = computed<boolean>(() => auth.user?.hasRoleSuperAdmin ?? false);
const isLoggedIn = computed<boolean>(() => auth.user !== null);
const isPageTop = computed<boolean>(() => String(route.name ?? '').indexOf('Top') === 0);
const isAdminPageGroup = computed<boolean>(() => String(route.name ?? '').indexOf('Admin') === 0);
const isDevDebugPageGroup = computed<boolean>(() => String(route.name ?? '').indexOf('DevDebug') === 0);


const onNavVarClick = (evt: Event) => {
  // 押されたら閉じる
  const target = evt.target as HTMLElement;
  if (target.classList.contains('nav-link')) {
    if (refNavbarCollapse.value) {
      $(refNavbarCollapse.value).collapse('hide');
    }
  }
};
const logout = async() => {
  // logout API が失敗してもローカルのセッションは破棄してログイン画面へ戻す
  let redirectUrl = '';
  try {
    const response = await auth.logout();
    redirectUrl = response.redirectUrl ?? '';
  } finally {
    clearSession();
    location.href = redirectUrl || '/login';
  }
};
</script>

<style scoped lang="scss">
.navbar-brand {
  position: relative;

  .env {
    position: absolute;
    font-size: 10px;
    top: -4px;
    left: -10px;
    padding: 1px 4px;
    &.dev {
      color: #00b300;
    }
    &.stg {
      color: orange;
    }
  }
}
.nav-right-side {
  li {
    list-style: none;
  }
  .user-display-name {
    color: rgba(255, 255, 255, 0.5)
  }
  .logout {
    color: #ffffff;
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
